<h3 class="panel-title">{{ termKey.AccompanimentServicePlural | term }}</h3>
@if (assistance.assistanceServices.length) {
  <table
    mat-table
    multiTemplateDataRows
    [dataSource]="
      assistance.assistanceServices
        | paginate
          : {
              id: 'services-' + assistance.id,
              itemsPerPage: servicesLimit,
              currentPage: servicePage,
              totalItems: assistance.assistanceServices.length,
            }
    "
  >
    <ng-container matColumnDef="controls">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let service">
        <a
          mat-icon-a
          (click)="toggleActivities(service)"
          [attr.aria-label]="
            isServiceExpanded(service.id) ? 'Ocultar actividades' : 'Ver actividades'
          "
        >
          <mat-icon class="main-icon">{{
            isServiceExpanded(service.id) ? 'expand_less' : 'chevron_right'
          }}</mat-icon>
        </a>
        <a mat-icon-a [matMenuTriggerFor]="serviceMenu" aria-label="Acciones" title="Acciones">
          <mat-icon class="main-icon">menu</mat-icon>
        </a>
        <mat-menu #serviceMenu="matMenu" class="icon-menu">
          <button
            mat-menu-item
            class="icon-button"
            appPermision="/assistanceservice+u"
            (click)="updateService(service)"
          >
            <span class="text-span"
              ><mat-icon class="icon-size">edit</mat-icon>Editar
              {{ termKey.AccompanimentServiceSingular | term }}</span
            >
          </button>
          <button
            class="icon-button"
            mat-menu-item
            appPermision="/serviceactivity+u"
            (click)="openAssignCargo(service)"
          >
            <span class="text-span"
              ><mat-icon class="icon-size">assignment</mat-icon> Asignar cargo</span
            >
          </button>
          <button
            mat-menu-item
            class="icon-button"
            appPermision="/serviceactivity+u"
            (click)="openAssignFixedAssets(service)"
          >
            <span class="text-span"
              ><mat-icon class="icon-size">inventory</mat-icon> Asignar
              {{ termKey.FixedAssetSingular | term }}</span
            >
          </button>
          <button
            mat-menu-item
            class="icon-button"
            appPermision="/serviceactivity+u"
            (click)="openAssignInfraestructure(service)"
          >
            <span class="text-span"
              ><mat-icon class="icon-size">factory</mat-icon> Asignar infraestructura</span
            >
          </button>
          <button
            mat-menu-item
            class="icon-button"
            appPermision="/serviceactivity+u"
            (click)="createServiceactivity(service)"
          >
            <span class="text-span"
              ><mat-icon class="icon-size">add_circle</mat-icon> Crear
              {{ termKey.ActivityServiceSingular | term }}</span
            >
          </button>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            class="icon-button"
            appOnlysuperuser="/assistanceservice"
            (click)="deleteService(service)"
          >
            <span class="text-span delete-span"
              ><mat-icon class="icon-size delete-icon">delete</mat-icon> Eliminar
              {{ termKey.AccompanimentServiceSingular | term }}</span
            >
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let assistanceService">
        {{ assistanceService.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let assistanceService">
        {{ assistanceService.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="components">
      <th mat-header-cell *matHeaderCellDef>Componentes</th>
      <td mat-cell *matCellDef="let assistanceService">
        {{ assistanceService.components?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="humanResources">
      <th mat-header-cell *matHeaderCellDef>Cargo</th>
      <td mat-cell *matCellDef="let assistanceService">
        @if (assistanceService.humanResources?.length) {
          <ul>
            @for (hr of assistanceService.humanResources; track hr.id) {
              @for (e of hr.employee; track e.id) {
                <li>{{ e.name }}</li>
              }
            }
          </ul>
        } @else {
          <span>No registra</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="fixedAsset">
      <th mat-header-cell *matHeaderCellDef>{{ termKey.FixedAssetPlural | term }}</th>
      <td mat-cell *matCellDef="let assistanceService">
        @if (assistanceService.FixedAssetExpense?.length) {
          <ul>
            @for (fa of assistanceService.FixedAssetExpense; track fa.id) {
              @for (f of fa.fixedAsset; track f.id) {
                <li>{{ f.name }}</li>
              }
            }
          </ul>
        } @else {
          <span>No registra</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="infraestructure">
      <th mat-header-cell *matHeaderCellDef>Infraestructura</th>

      <td mat-cell *matCellDef="let assistanceService">
        @if (assistanceService.infraestructure?.length) {
          <ul class="m-0 ps-3">
            @for (infra of assistanceService.infraestructure; track infra.id) {
              @for (i of infra.infraestructure; track i.id) {
                <li>
                  {{ i.name }}
                </li>
              }
            }
          </ul>
        } @else {
          <span>No registra</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="locations">
      <th mat-header-cell *matHeaderCellDef>Ubicación</th>

      <td mat-cell *matCellDef="let assistanceService">
        @if (assistanceService.locations?.length) {
          <ul>
            @for (lo of assistanceService.locations; track lo) {
              <li>{{ lo.city }} - {{ lo.department }}</li>
            }
          </ul>
        } @else {
          <span>No registra</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="lifePlan">
      <th mat-header-cell *matHeaderCellDef>Plan de vida</th>

      <td mat-cell *matCellDef="let assistanceService">
        @if (assistanceService.lifePlan?.length) {
          <ul>
            @for (lp of assistanceService.lifePlan; track lp) {
              <li>{{ lp.name }}</li>
            }
          </ul>
        } @else {
          <span>No registra</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="territory">
      <th mat-header-cell *matHeaderCellDef>Territorio</th>

      <td mat-cell *matCellDef="let assistanceService">
        @if (assistanceService.territory?.length) {
          <ul>
            @for (t of assistanceService.territory; track t) {
              <li>{{ t.name }}</li>
            }
          </ul>
        } @else {
          <span>No registra</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>Total</th>
      <td mat-cell *matCellDef="let assistanceService">
        {{ assistanceService.total }}
      </td>
    </ng-container>

    <ng-container matColumnDef="activitiesDetail">
      <td mat-cell *matCellDef="let service" [attr.colspan]="serviceColumns.length">
        @if (isServiceExpanded(service.id)) {
          <app-assistanceservice-serviceactivity-list
            [service]="service"
            (changed)="changed.emit()"
          ></app-assistanceservice-serviceactivity-list>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="serviceColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: serviceColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['activitiesDetail']"
      class="activities-detail-row"
    ></tr>
  </table>
  @if (assistance.assistanceServices.length > servicesLimit) {
    <pagination-controls
      [id]="'services-' + assistance.id"
      (pageChange)="servicePage = $event"
      previousLabel="Anterior"
      nextLabel="Siguiente"
    ></pagination-controls>
  }
} @else {
  <p class="empty-label">No registra servicios.</p>
}
